import { type FileWithPath } from 'react-dropzone';
import { create } from 'zustand';

export type ExtendedFileWithPath = FileWithPath & {
  folderPath: string;
  preview: string;
  id: string;
};

interface BrowserStore {
  isAllSelected: boolean;
  setIsAllSelected: (value: boolean) => void;
  nodeAssetsCount: number | undefined;
  setNodeAssetsCount: (value: number | undefined) => void;
  scrollToAssetId: string | undefined;
  setScrollToAssetId: (value: string | undefined) => void;
  locateAssetId: string | undefined;
  setLocateAssetId: (value: string | undefined) => void;
}

export const useBrowserStore = create<BrowserStore>((set, _get) => ({
  isAllSelected: false,
  setIsAllSelected: (value: boolean) =>
    set((state) => ({
      ...state,
      isAllSelected: value,
    })),
  nodeAssetsCount: undefined,
  setNodeAssetsCount: (value: number | undefined) =>
    set((state) => ({
      ...state,
      nodeAssetsCount: value,
    })),
  scrollToAssetId: undefined,
  setScrollToAssetId: (value: string | undefined) =>
    set((state) => ({
      ...state,
      scrollToAssetId: value,
    })),
  locateAssetId: undefined,
  setLocateAssetId: (value: string | undefined) =>
    set((state) => ({
      ...state,
      locateAssetId: value,
    })),
}));
